require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-10-questions-with-james-coogan.json") })
        }
      }, "path---authors-10-questions-with-james-coogan");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-10-questions-with-james-coogan!./.cache/json/authors-10-questions-with-james-coogan.json
// module id = 1241
// module chunks = 231608221292675